import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CellType, FlexGrid } from '@grapecity/wijmo.grid';
import { EventArgs } from '@grapecity/wijmo';

import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';

import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1402Model } from './kymw1402.model';
import { KYMW1402InputModel } from './vo/kymw1402-input.model';

import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { VMediumTypeComboBoxComponent } from '../../../commons/kymw02/combo-box/vmedium-type-combo-box/vmedium-type-combo-box.component';

import { GetKomaPrintDataService } from './api-services/get-koma-print-data.service';
import { GetPrintPageDataService } from './api-services/get-print-page-data.service';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { PageDataModel } from '../kymw1400/vo/page-data.model';
import { KomaPrintDataModel } from '../kymw1400/vo/koma-print-date.model';

/**
 * 誌面印刷画面を管理するクラス
 *
 * @export KYMW1402Component
 * @class KYMW1402Component
 */
@Component({
  selector: 'app-kymw1402',
  templateUrl: 'kymw1402.component.html',
  styleUrls: ['kymw1402.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1402Component extends PlessViewHelperSub implements OnInit {
  @ViewChild('txti_OrderCode', { static: true }) txti_OrderCode: OrderCodeTextInputComponent;
  @ViewChild('cmb_MediumType', { static: true }) cmb_MediumType: VMediumTypeComboBoxComponent;
  @ViewChild('li_PageList', { static: true }) li_PageList: FlexGrid;

  /**
   * 受渡情報ＶＯ
   */
  private inputVO: KYMW1402InputModel = null;

  /** 生協コードマスタ */
  private coopData: Array<any> = null;

  public closeFunction: Function = null;
  public kymw1402Model: KYMW1402Model = new KYMW1402Model();

  /**
   *Creates an instance of KYMW1402Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {GetKomaPrintDataService} getKomaPrintDataService
   * @param {GetPrintPageDataService} getPrintPageDataService
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @memberof KYMW1402Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getKomaPrintDataService: GetKomaPrintDataService,
    private getPrintPageDataService: GetPrintPageDataService,
    private fileDownloadConfirmService: FileDownloadConfirmService,
  ) {
    super(kymw00Model);

    // 生協コード値のマップ
    this.coopData = [];
    this.coopData['chk_Ibaraki'] = this.kymw00Model.COOP_CODE_IB;
    this.coopData['chk_Tochigi'] = this.kymw00Model.COOP_CODE_TO;
    this.coopData['chk_Gunma'] = this.kymw00Model.COOP_CODE_GU;
    this.coopData['chk_Chiba'] = this.kymw00Model.COOP_CODE_TI;
    this.coopData['chk_Saitama'] = this.kymw00Model.COOP_CODE_SA;
    this.coopData['chk_Tokyo'] = this.kymw00Model.COOP_CODE_TK;
    this.coopData['chk_Nagano'] = this.kymw00Model.COOP_CODE_NA;
    this.coopData['chk_Niigata'] = this.kymw00Model.COOP_CODE_NI;
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1402Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1402';
    // 受渡情報をManageに設定
    this.kymw1402Model.orderCode = this.inputVO.orderCode;
    this.kymw1402Model.mediumType = this.inputVO.mediumType;

    this.txti_OrderCode.setOrderCode(this.inputVO.orderCode);
    this.cmb_MediumType.setMediumType(this.inputVO.mediumType);

    // 「いばらき」の場合
    if (this.kymw00Model.COOP_CODE_IB === this.inputVO.coopCode) {
      this.kymw1402Model.chkIbaraki = true;
    }
    // 「とちぎ」の場合
    if (this.kymw00Model.COOP_CODE_TO === this.inputVO.coopCode) {
      this.kymw1402Model.chkTochigi = true;
    }
    // 「ぐんま」の場合
    if (this.kymw00Model.COOP_CODE_GU === this.inputVO.coopCode) {
      this.kymw1402Model.chkGunma = true;
    }
    // 「ちば」の場合
    if (this.kymw00Model.COOP_CODE_TI === this.inputVO.coopCode) {
      this.kymw1402Model.chkChiba = true;
    }
    // 「さいたま」の場合
    if (this.kymw00Model.COOP_CODE_SA === this.inputVO.coopCode) {
      this.kymw1402Model.chkSaitama = true;
    }
    // 「とうきょう」の場合
    if (this.kymw00Model.COOP_CODE_TK === this.inputVO.coopCode) {
      this.kymw1402Model.chkTokyo = true;
    }
    // 「ながの」の場合
    if (this.kymw00Model.COOP_CODE_NA === this.inputVO.coopCode) {
      this.kymw1402Model.chkNagano = true;
    }
    // 「にいがた」の場合
    if (this.kymw00Model.COOP_CODE_NI === this.inputVO.coopCode) {
      this.kymw1402Model.chkNiigata = true;
    }

    // 活性制御
    this.activeControl();

    this.li_PageList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.li_PageList.select(-1, -1);
    });

    this.li_PageList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.li_PageList.hitTest(e);
      if ((0 <= ht.row) && (0 == ht.col) && !ht.target.className.includes("wj-header")) {
        document.getElementById(`cb_page_list_${ht.row}`).click();
      }
    });
  }

  /**
   * パラメータ受け取り
   *
   * @param {*} inputVO
   * @memberof KYMW1402Component
   */
  public inputParameterSetting(): void {
    this.inputVO = this.iInputVOArray;
  }

  /**
   * 受注コードが変更されたときのイベント
   *
   * @memberof KYMW1402Component
   */
  public eventOrderCode_CHANGEHandler(): void {

    if (this.inputVO === null) {
      // 媒体コンボボックスクリア
      this.cmb_MediumType.setMediumType('');
      this.kymw1402Model.mediumType = '';
    } else {
      this.inputVO = null;
    }

    // ページ一覧をクリア
    this.kymw1402Model.pageListClear();

    // 活性制御
    this.activeControl();
  }

  /**
   * 媒体コンボボックスが変更されたときのイベント
   *
   * @memberof KYMW1402Component
   */
  public eventMediumType_CHANGEHandler(): void {
    // ページ一覧をクリア
    this.kymw1402Model.pageListClear();

    // 活性制御
    this.activeControl();
  }

  /**
   * 会員生協（全生協）チェックボックスが変更されたときのイベント
   *
   * @memberof KYMW1402Component
   */
  public eventAllCoop_CHANGEHandler(): void {
    // 会員生協（各生協）チェックボックスの選択状態を設定する
    this.kymw1402Model.chkIbaraki = this.kymw1402Model.chkAllCoop;
    this.kymw1402Model.chkTochigi = this.kymw1402Model.chkAllCoop;
    this.kymw1402Model.chkGunma = this.kymw1402Model.chkAllCoop;
    this.kymw1402Model.chkChiba = this.kymw1402Model.chkAllCoop;
    this.kymw1402Model.chkSaitama = this.kymw1402Model.chkAllCoop;
    this.kymw1402Model.chkTokyo = this.kymw1402Model.chkAllCoop;
    this.kymw1402Model.chkNagano = this.kymw1402Model.chkAllCoop;
    this.kymw1402Model.chkNiigata = this.kymw1402Model.chkAllCoop;

    // ページ一覧をクリア
    this.kymw1402Model.pageListClear();

    // 活性制御
    this.activeControl();
  }


  /**
   * 会員生協（各生協）チェックボックスが変更されたときのイベント
   *
   * @memberof KYMW1402Component
   */
  public eventCoop_CHANGEHandler(): void {
    // ページ一覧をクリア
    this.kymw1402Model.pageListClear();

    // 活性制御
    this.activeControl();
  }

  /**
   * 表示ボタンが押下されたときのイベント
   *
   * @memberof KYMW1402Component
   */
  public eventDisplay_CLICKHandler(): void {
    // ページ一覧をクリア
    this.kymw1402Model.pageListClear();

    // 再検索
    this.dispatcherGetPrintPageEvent();
  }

  /**
   * 全て選択ボタンが押下されたときのイベント
   *
   * @memberof KYMW1402Component
   */
  public eventAllSelect_CLICKHandler(): void {
    // ページ一覧のチェックボックスを全てチェック
    this.kymw1402Model.changeCheckMode(true);
  }

  /**
   * 全て解除ボタンが押下されたときのイベント
   *
   * @memberof KYMW1402Component
   */
  public eventAllRelease_CLICKHandler(): void {
    // ページ一覧のチェックボックスをすべて解除
    this.kymw1402Model.changeCheckMode(false);
  }

  /**
   * 出力ボタンが押下されたときのイベント
   *
   * @returns {void}
   * @memberof KYMW1402Component
   */
  public eventOut_CLICKHandler(): void {
    const vo = this.createKomaPrintDataVO();

    // 検索条件が埋まってなければ
    if (PlessViewUtilsSub.isEmpty(vo.orderCode)
      || PlessViewUtilsSub.isEmpty(vo.mediumType)) {
      this.dialogService.openAlertGetMessage('E0103', ['出力対象']);
      return;
    }

    // 生協が選択されていない場合は処理を中止
    if (vo.coopCodeList.length === 0) {
      this.dialogService.openAlertGetMessage('E0103', ['会員生協']);
      return;
    }

    // ページが選択されていない場合は処理を中止
    if (vo.pageArray.length === 0) {
      this.dialogService.openAlertGetMessage('E0103', ['ページ']);
      return;
    }
    this.getKomaPrintDataService.execute(vo, this.fileDownloadConfirmService);
  }

  /**
   * 閉じるボタンが押下されたときのイベント
   *
   * @memberof KYMW1402Component
   */
  public eventWindowClose_CLICKHandler(): void {

    // 画面終了
    this.closeFunction();
  }

  /*--------------------------------------------------------------------------------------------
  /* other
  /*--------------------------------------------------------------------------------------------*/
  /**
   * ページ情報取得イベント発行
   *
   * @private
   * @memberof KYMW1402Component
   */
  private dispatcherGetPrintPageEvent(): void {
    const vo = this.createPageDataVO();
    this.getPrintPageDataService.execute(this.kymw1402Model, vo);
  }

  /**
   * 活性制御.
   *
   * @private
   * @memberof KYMW1402Component
   */
  private activeControl(): void {
    // 入力チェック
    if (!PlessViewUtilsSub.isEmpty(this.kymw1402Model.orderCode)                // 受注コードが入力あり、
      && !PlessViewUtilsSub.isEmpty(this.kymw1402Model.mediumType)              // 媒体区分が入力あり、
      && this.isSelectedCoop()) {                                               // 会員生協が入力ありの場合
      // 表示ボタンの活性制御
      this.kymw1402Model.disabledDisplay = false;
    } else {
      // 未入力ありの場合
      // 表示ボタンの活性制御
      this.kymw1402Model.disabledDisplay = true;
    }
  }

  /**
   * 会員生協選択判定
   *
   * @private
   * @returns {boolean}
   * @memberof KYMW1402Component
   */
  private isSelectedCoop(): boolean {
    // 会員生協チェックボックスの選択状態の確認
    if (!this.kymw1402Model.chkIbaraki                                          // 全ての生協が未選択の場合
      && !this.kymw1402Model.chkTochigi
      && !this.kymw1402Model.chkGunma
      && !this.kymw1402Model.chkChiba
      && !this.kymw1402Model.chkSaitama
      && !this.kymw1402Model.chkTokyo
      && !this.kymw1402Model.chkNagano
      && !this.kymw1402Model.chkNiigata) {
      // 判定結果を返却
      return false;
    } else {
      // いずれかの生協が選択の場合
      // 判定結果を返却
      return true;
    }
  }


  /**
   * 誌面印刷 ページ一覧リクエスト用VOセット
   *
   * @private
   * @returns {PageDataModel}
   * @memberof KYMW1402Component
   */
  private createPageDataVO(): PageDataModel {
    const vo: PageDataModel = new PageDataModel();

    vo.orderCode = this.kymw1402Model.orderCode;                                // 受注コード
    vo.mediumType = this.kymw1402Model.mediumType;                              // 媒体
    vo.coopCodeList = this.createCoopCodeList();                                // 生協コードリスト

    // 誌面印刷 ページ一覧リクエスト用VOを返却
    return vo;
  }

  /**
   * 誌面印刷 出力リクエスト用VOセット
   *
   * @private
   * @returns {KomaPrintDataModel}
   * @memberof KYMW1402Component
   */
  private createKomaPrintDataVO(): KomaPrintDataModel {
    const vo: KomaPrintDataModel = new KomaPrintDataModel();

    vo.orderCode = this.txti_OrderCode.selectedOrderCode;
    vo.catalogId = this.txti_OrderCode.selectedCatalogID;
    vo.mediumType = this.cmb_MediumType.selectedMediumType;
    vo.mediumName = this.cmb_MediumType.selectedMediumName;
    vo.showKoma = PlessViewUtilsSub.booleanTOString(this.kymw1402Model.chkShowKoma);
    vo.showGoods = PlessViewUtilsSub.booleanTOString(this.kymw1402Model.chkShowGoods);
    vo.showImage = PlessViewUtilsSub.booleanTOString(this.kymw1402Model.chkShowImage);
    vo.coopCodeList = this.createCoopCodeList();                                // 生協コードリスト
    vo.pageArray = this.createPageNumList();                                    // ページ番号リスト

    // 誌面印刷 出力リクエスト用VOを返却
    return vo;
  }

  /**
   * 生協コードリスト作成
   *
   * @private
   * @returns {Array<any>}
   * @memberof KYMW1402Component
   */
  private createCoopCodeList(): Array<any> {
    const coopCodeList: Array<any> = new Array<any>();                          // 生協コードリスト

    // 会員生協
    if (this.kymw1402Model.chkIbaraki) {
      coopCodeList.push(this.coopData['chk_Ibaraki']);
    }
    if (this.kymw1402Model.chkTochigi) {
      coopCodeList.push(this.coopData['chk_Tochigi']);
    }
    if (this.kymw1402Model.chkGunma) {
      coopCodeList.push(this.coopData['chk_Gunma']);
    }
    if (this.kymw1402Model.chkChiba) {
      coopCodeList.push(this.coopData['chk_Chiba']);
    }
    if (this.kymw1402Model.chkSaitama) {
      coopCodeList.push(this.coopData['chk_Saitama']);
    }
    if (this.kymw1402Model.chkTokyo) {
      coopCodeList.push(this.coopData['chk_Tokyo']);
    }
    if (this.kymw1402Model.chkNagano) {
      coopCodeList.push(this.coopData['chk_Nagano']);
    }
    if (this.kymw1402Model.chkNiigata) {
      coopCodeList.push(this.coopData['chk_Niigata']);
    }

    return coopCodeList;
  }

  /**
   * ページ番号リスト作成
   *
   * @private
   * @returns {Array<any>}
   * @memberof KYMW1402Component
   */
  private createPageNumList(): Array<any> {
    // 選択リスト
    const selectList: Array<any> = new Array<any>();
    // ページ一覧
    const pageList: Array<any> = this.li_PageList.itemsSource;

    // ページ一覧でチェックされているものをリスト化
    for (let i = Number(0); i < pageList.length; i++) {
      // 選択状態のチェック
      if (pageList[i].Selected === true) {                                   // 選択されている場合
        // 選択リストにページ番号を追加
        selectList.push(pageList[i].PageNum);
      }
    }

    // 選択リストを返却
    return selectList;
  }
}
